// extracted by mini-css-extract-plugin
module.exports = {"pin":"da51a739f7--pin--pyJQJ","slidein":"da51a739f7--slidein--NiCZs","pin--image":"da51a739f7--pin--image--MQdS8"};